import React, { Component } from 'react';
import { Modal, Col } from "react-bootstrap";

class CustomModalHome extends Component {
    state = {
        show: this.props.isopen,
    }

    cerrarModal = () => (e) => {
        this.setState({ show: false });
        this.props.cerrar();
    }

    componentWillReceiveProps (props) {
        this.setState({
            show: props.isopen
        });
    }

    render() {
        const { contenido, large } = this.props;
        return (
            <Modal bsSize ={large}  show = {this.state.show} onHide = {this.cerrarModal()}>
                <Modal.Body  onClick = {this.cerrarModal()}>{contenido}</Modal.Body>
            </Modal>
        );
    }
}
 
export default CustomModalHome;


// WEBPACK FOOTER //
// ./src/components/Modal/CustomModalHome.jsx